export enum GenderTypes {
	Male = "M",
	Female = "F",
	Other = "O",
	Unknown = "U",
}
